TiposActionsService.$inject = ['$log', 'dialogService', '$http'];
export default function TiposActionsService($log, dialogService, $http) {

    var TAG = 'TiposActionsService: ';
    var DIALOG_EDIT_TIPO_TEMPLATE = require('./edit/dialog-edit-tipo.html');
    var DIALOG_EDIT_TIPO_ID = 'dialog-edit-tipo';

    var DIALOG_EDIT_CONFIG_TIPO_TEMPLATE = require('./edit-config/dialog-edit-config-tipo.html');
    var DIALOG_EDIT_CONFIG_TIPO_ID = 'dialog-edit-config-tipo';

    var DIALOG_EDIT_CONFIG_TIPO_DISTRITO_TEMPLATE = require('./edit-config-distrito/dialog-edit-config-tipo-distrito.html');
    var DIALOG_EDIT_CONFIG_TIPO_DISTRITO_ID = 'dialog-edit-config-tipo-distrito';

    var URL_TIPOS_BASE = Sigo.var.path + '/tipos';

    function _editarTipo(tipoId) {
        var titulo = 'Editando tipo ' + tipoId;
        var options = {title: titulo};
        var datos = {tipoId: tipoId};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_EDIT_TIPO_ID, DIALOG_EDIT_TIPO_TEMPLATE, datos, options, opcionesExtra);
    }


    function _crearTipo() {

    }

    function _editarConfigAsignacion(tipoUnidadGestionId) {
        var titulo = 'Editando configuración del tipo ' + tipoUnidadGestionId;
        var options = {title: titulo};
        var datos = {tipoUnidadGestionId: tipoUnidadGestionId};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_EDIT_CONFIG_TIPO_ID, DIALOG_EDIT_CONFIG_TIPO_TEMPLATE, datos, options, opcionesExtra);
    }

    function _editarConfigAsignacionDistrito(unidadGestionTipoDistritoId) {
        var titulo = 'Editando configuración del tipo distrito ' + unidadGestionTipoDistritoId;
        var options = {title: titulo};
        var datos = {unidadGestionTipoDistritoId: unidadGestionTipoDistritoId, metodo: "edit"};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_EDIT_CONFIG_TIPO_DISTRITO_ID, DIALOG_EDIT_CONFIG_TIPO_DISTRITO_TEMPLATE, datos, options, opcionesExtra);
    }

    function _addConfigAsignacionDistrito(unidadGestionTipoId) {
        var titulo = 'Añadir configuración del tipo distrito ' + unidadGestionTipoId;
        var options = {title: titulo};
        var datos = {unidadGestionTipoId: unidadGestionTipoId, metodo: "add"};
        var opcionesExtra = {deshabilitarBotones: true};

        return dialogService.open(DIALOG_EDIT_CONFIG_TIPO_DISTRITO_ID, DIALOG_EDIT_CONFIG_TIPO_DISTRITO_TEMPLATE, datos, options, opcionesExtra);
    }

    return {
        crearTipo: _crearTipo,
        editarTipo: _editarTipo,
        editarConfigAsignacion: _editarConfigAsignacion,
        editarConfigAsignacionDistrito: _editarConfigAsignacionDistrito,
        addConfigAsignacionDistrito: _addConfigAsignacionDistrito
    };
}